var _ = require('lodash');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!-- ko if: IsLoggedIn() --> <a data-bind="attr: { href: MyrgsHref }"data-toggle="dropdown"> Личный кабинет </a> <div class="dropdown-menu animated"> <ul><!-- ko foreach: Links --> <li> <a data-bind="attr: { href: href }, text: text"></a> </li><!-- /ko --> <li> <a href="#"data-bind="click: onLogoutClick"> Выход <i class="fa fa-sign-out"aria-hidden="true"></i> </a> </li> </ul> </div><!-- /ko --><!-- ko if: !IsLoggedIn() --> <a data-bind="attr: { href: MyrgsHref }"> Личный кабинет </a> <!-- /ko -->';
}
return __p;
};
